module.exports = __webpack_public_path__ + "d99a70b7ce2601aede848da89c0dee4f.png";